import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { initSliders } from './slider/dc-slider.js';


const HeaderBannerWithSlider = ({ isBrowserRendering, htmlContent }) => {
  const onRefChange = useCallback((bannerDOMElement) => {
    if (bannerDOMElement !== null) {
      initSliders(bannerDOMElement);
    }
  }, []);


  return isBrowserRendering
    ? (
      <div
        ref={onRefChange}
        dangerouslySetInnerHTML={{ __html: htmlContent }}
        style={{ paddingBottom: '10px' }}
      />
    ) : null;
};

HeaderBannerWithSlider.displayName = 'HeaderBannerWithSlider';

HeaderBannerWithSlider.propTypes = {
  isBrowserRendering: PropTypes.bool.isRequired,
  htmlContent: PropTypes.string.isRequired
};

export default HeaderBannerWithSlider;
